<div
  *ngIf="opened"
  (click)="$event.stopPropagation()"
  class="absolute top-14 z-40 left-0">
  <emoji-mart
    [virtualize]="true"
    [darkMode]="false"
    (emojiClick)="addEmoji($event)"></emoji-mart>
</div>
